export const advancedDropdownInjectionKey = 'advanced-dropdown'
